module.exports = __webpack_public_path__ + "img/3.e620bcc8.webp";